import miscellaneousVehicle, {
  isMiscellaneousVehicleByMake,
} from '../search/Results/utils/miscellaneousVehicle'
import { Order, OrderResponse } from '../../api/cart/interfaces'
import VehicleServiceProvider from '../../services/VehicleServiceProvider'
import { ISetQtyProps } from 'cart'
import { setQtyAtLocationBulk } from 'libs/cart/src/utils/Utils'
import { Vehicle } from '../../store/models/Vehicles'
import MultiSellerServicesProvider, {
  ISeller,
} from '../../services/MultiSellerServicesProvider'
import { MY_PLACE_SELLER } from 'common'

const getSellerInfoData = async (
  coverageKey: string | null
): Promise<ISeller> => {
  if (!coverageKey) {
    return MY_PLACE_SELLER
  }

  try {
    const response = await MultiSellerServicesProvider.getActiveSellers()
    const match = (response || []).find(
      (item) => item.coverageKey === coverageKey
    )
    return match ? match : MY_PLACE_SELLER
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    // eslint-disable-next-line no-console
    console.error(err)
    return MY_PLACE_SELLER
  }
}

export const extractErrorOrders = async (
  response: OrderResponse
): Promise<ISetQtyProps[]> => {
  const result: ISetQtyProps[] = []
  const { orderDetails } = response

  for (const orderDetail of orderDetails) {
    for (const location of orderDetail.locations) {
      const coverageKey: string | null = location?.coverageKey
      for (const order of location.orders) {
        if (order.orderError) {
          for (const part of order.parts) {
            let vehicle: Vehicle
            if (isMiscellaneousVehicleByMake(orderDetail.vehicle)) {
              vehicle = miscellaneousVehicle
            } else {
              const ymme =
                orderDetail.vehicle.year +
                ',' +
                orderDetail.vehicle.make +
                ',' +
                orderDetail.vehicle.model +
                ',' +
                orderDetail?.vehicle?.engine
              vehicle = await VehicleServiceProvider.getDecodedAndValidatedYMME(
                {
                  ymme,
                }
              )
            }
            const sellerData = await getSellerInfoData(coverageKey)
            result.push({
              product: {
                ...part,
                location: [],
              },
              locationId: part.locationId,
              quantity: part.quantityRequested,
              autoLocationChange: false,
              vehicle,
              seller: sellerData,
            })
          }
        }
      }
    }
  }

  return result
}

export const restoreFailedOrderPartsToCart = async (
  response: OrderResponse
): Promise<void> => {
  const data = await extractErrorOrders(response)
  await setQtyAtLocationBulk(data, true)
}

export const handleBackToCart = async (
  response: OrderResponse | undefined,
  navigate: (path: string) => void
): Promise<void> => {
  if (!response) {
    navigate('/cart')
    return
  }

  try {
    await restoreFailedOrderPartsToCart(response)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to restore parts to cart:', error)
  }

  navigate('/cart')
}

export const ordersWithErrors = (response: OrderResponse): Order[] => {
  return response.orderDetails
    ?.flatMap((o) => o.locations)
    .flatMap((l) => l.orders)
    .filter((o) => o.orderError)
}

export const hasErrors = (response: OrderResponse): boolean => {
  return ordersWithErrors(response)?.length > 0
}
